/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
// Common
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Navigate } from "react-router-dom";
//Auth
import { isAuthenticatedTutor } from "./services/TutorAuth.js"; //import auth
//Loading
import LoadingSpinner from "../LoadingSpinner";
import TutorClassViewer from "./TutorClassViewer";
import TutorBlockViewer from "./TutorBlockViewer";

const TutorOverview = () => {
  // Manage State
  const [classes, setClasses] = useState([]);
  const [blocks, setBlocks] = useState([]);

  // Get the overview list of classes.
  useEffect(async () => {
    const getData = await axios.get(`/api/tutor/manage/overview/`, {
      withCredentials: true,
    });
    setBlocks(getData.data.blockData);
    return setClasses(getData.data.classData);
  }, []);

  return (
    <div className='OverviewClassViewer'>
      {isAuthenticatedTutor() ? (
        <FadeIn delay={250} duration={450}>
          <div>
            {classes && <TutorClassViewer classes={classes} />}
            {blocks && <TutorBlockViewer blocks={blocks} />}
            {!classes && !blocks && <LoadingSpinner />}
          </div>
        </FadeIn>
      ) : (
        <Navigate to='/tutor/' />
      )}
    </div>
  );
};

export default TutorOverview;
